import React from 'react';

import {
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  translatedLabels,
  privateColor,
} from '../../library/constants';
import { getNodeFromNodeObjsWithPrId, urlGet/*, truncateWord*/, isMobilePhone} from '../../library/calc';

import Base from './base';

class SinglePartner extends Base {

  getSinglePartnerTR(idx){

    const {
      nodeObjs,
      addNodeFormFocus,
      onClickEdit,
      reloadCanvasTree,
      openAddNodeForm,
    } = this.props;

    const immediateFam = this.props.nodeObj.immediateFam;

    let partnersDom = undefined;
    if(immediateFam.partners.length > 0){

      let partnerFullname =  immediateFam.partners[0].nm;
      // partnerFullname = titleCase(partnerFullname);
      // const maxWidth = ( this.props.immediateFamVersion === 'addbox' ? 27: 35);
      // partnerFullname =  truncateWord({str:partnerFullname, length: maxWidth, useWordBoundary: false})


      if(urlGet('nodeIs') === "n") partnerFullname = `${immediateFam.partners[0].nm} - ${immediateFam.partners[0].n}`;
      if(urlGet('nodeIs') === "prId") partnerFullname = `${immediateFam.partners[0].nm} - ${immediateFam.partners[0].prId}`;

      let otherParnerGenderChoice = (this.props.nodeObj.g === 'm' ? 'wife': 'husband');
      otherParnerGenderChoice = (immediateFam.partners[0].g === 'u' ? 'spouse': otherParnerGenderChoice)

      let colorOfGender = immediateFam.partners[0].g === 'm' ? maleDefaultColor: femaleDefaultColor;
      if(immediateFam.partners[0].g === 'u'){
        colorOfGender = unGenderedDefaultColor;
      }

      if(typeof(immediateFam.partners[0].nvp) !== 'undefined'){
        colorOfGender = privateColor;
      }

      const isGhost = () => {
        return typeof(immediateFam.partners[0].nt) !== 'undefined'
      }

      partnersDom =
        <tr key={`trPartner${'1'}`}>
          <td className='family-list'>
            <div>
              <div  className='flip-anchor-bullet' style={{
                color: `${colorOfGender}`,
              }}>◉&nbsp;
              </div>
              <div className="flip-anchor-link" onClick={()=>{
                  if(isGhost() ){
                    if(!isMobilePhone()){
                      openAddNodeForm({
                        node: addNodeFormFocus,
                        relationShip: otherParnerGenderChoice,
                        marriageId: immediateFam.partners[0].marriageId,
                        nodeIsGhost: true,
                      });
                    }

                    return;

                  } else {
                    this.onClick(immediateFam.partners[0]);
                  }
                }}
              >
                {partnerFullname}
              </div>
              <div>
                &nbsp;&nbsp;
                <span
                  className={ `svgicon ${(isGhost() || this.props.immediateFamVersion === 'flipPanel' ? 'hide': '')}`  }
                  style={this.getIconStyle().tree}
                  onClick={()=>{
                      if( this.props.chartType === 'fan') this.props.refocusFanChart({prId: immediateFam.partners[0].prId})
                      else reloadCanvasTree(immediateFam.partners[0].prId);
                    // reloadCanvasTree(immediateFam.partners[0].prId);
                  }}
                >&nbsp;</span>
                <span
                  className={ `svgicon ${( typeof(immediateFam.partners[0].e) === 'undefined' ? 'hide': '')}`  }
                  style={this.getIconStyle().edit}
                  onClick={()=>{
                      const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: immediateFam.partners[0].prId, fromWhere: 'addbox'});
                      onClickEdit(n, immediateFam.partners[0].prId);
                  }}
                >&nbsp;
                </span>
              </div>
            </div>
          </td>
        </tr>
    }

    let childrenDoms = [];

    const childrenNodeIdsArray = immediateFam.children;

    childrenDoms = childrenNodeIdsArray.map((child, idx)=>{
      let colorOfGender = child.g === 'm' ? maleDefaultColor: femaleDefaultColor;
      if(child.g === 'u'){
        colorOfGender = unGenderedDefaultColor;
      }

      if(typeof(child.nvp) !== 'undefined'){
        colorOfGender = privateColor;
      }

      let childFullname = child.nm;
      // childFullname = titleCase(childFullname);
      // const maxWidth = ( this.props.immediateFamVersion === 'addbox' ? 27: 35);
      // childFullname =  truncateWord({str:childFullname, length: maxWidth, useWordBoundary: false})

      if(urlGet('nodeIs') === "n") childFullname = `${child.nm} - ${child.n}`;
      if(urlGet('nodeIs') === "prId") childFullname = `${child.nm} - ${child.prId}`;

      return (
        <tr key={`trChildren${idx}`}>
          <td className='family-list'>
            <div>
              <div  className='flip-anchor-bullet' style={{
                color: `${colorOfGender}`,
              }}>◉&nbsp;
              </div>
              <div  className='flip-anchor-link' onClick={()=>{
                    this.onClick(child);
                  }}
              >
                {childFullname}
              </div>
              <div>
                  &nbsp;&nbsp;<span
                    className={ `svgicon ${(this.props.immediateFamVersion === 'flipPanel' ? 'hide': '')}`  }
                    style={this.getIconStyle().tree}
                    onClick={()=>{
                      console.log(`this.props.chartType: `, this.props.chartType);
                      if( this.props.chartType === 'fan'){
                        this.props.refocusFanChart({prId: child.prId})
                      } else {
                        reloadCanvasTree(child.prId);
                      }
                      // reloadCanvasTree(child.prId);
                    }}
                  >&nbsp;
                  </span>
                  <span
                    className={ `svgicon ${( typeof(child.e) === 'undefined' ? 'hide': '')}`  }
                    style={this.getIconStyle().edit}
                    onClick={()=>{
                      const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: child.prId, fromWhere: 'addbox'});
                      onClickEdit(n, child.prId);
                    }}
                  >&nbsp;
                  </span>
              </div>
            </div>
          </td>
        </tr>
      );
    })

    return {
      partner: partnersDom,
      children: childrenDoms
    };

  }

  getSinglePartnerDomAndChildrenDom({addNodeFormFocus, canAddNode, openAddNodeForm}){

    return [
      this.getSinglePartnerTR().partner,
      <tr   key={`trHr-1`}  className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forPartners: true, forChildren: true}) ? '': 'hide-header')}`}>
        <td >
          <hr/>
        </td>
      </tr>,
      <tr  key={`trChildrenLabel-1`} className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forChildren: true}) ? '': 'hide-header')}`}>
        <td className='family-label'>
          {translatedLabels['Children'].translatedLabel}&nbsp;&nbsp;
          {

              canAddNode

            ?

              this.buildAddLinks({
                openAddNodeForm,
                maleRelation: 'son',
                femaleRelation: 'daughter',
                node: addNodeFormFocus
              })
            :

            null
          }

        </td>
      </tr>,
     ...this.getSinglePartnerTR().children
    ]
  }

}

export default SinglePartner;

